import { Link } from 'framework7-react';
import { HTMLAttributes, MouseEvent } from 'react';

interface SeoLinkProps extends HTMLAttributes<HTMLAnchorElement> {
  href: string;
}

export const SeoLink = ({ href, onClick, ...props }: SeoLinkProps) => {
  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onClick?.(e);
  };

  return (
    <Link
      href={href}
      onClick={handleClick}
      noLinkClass
      external
      style={{ color: 'inherit' }}
      {...props}
    />
  );
};
